import AppFooter from './components/AppFooter';

function Pfooter() {
    return <AppFooter />;
}

export default Pfooter;
